<div [class.content]="addPadding" class="h-full">
  <ng-content></ng-content>
</div>
